/* Our story-popup onder de koopknop (snippets/mv-verhaal.liquid, 3 nov 2026).
   Native <dialog>: showModal() geeft Escape, focus-in-de-popup en een inerte achtergrond. Hier alleen wat de browser
   niet zelf doet: openen, sluiten op de knoppen en op de achtergrond, de pagina niet laten scrollen, video pauzeren. */
if (!customElements.get('mv-verhaal')) {
  class MvVerhaal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-mv-verhaal-open]');
      if (!this.dialog || !this.opener) return;

      this.opener.addEventListener('click', () => this.open());
      this.dialog.querySelectorAll('[data-mv-verhaal-sluit]').forEach((knop) =>
        knop.addEventListener('click', () => this.dialog.close())
      );
      // Klik op de donkere achtergrond: het doel is dan de <dialog> zelf, niet de kaart erin.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mv-verhaal-open');
        this.dialog.querySelector('video')?.pause();
        this.opener.focus({ preventScroll: true });
      });
    }

    open() {
      if (typeof this.dialog.showModal !== 'function') {
        this.dialog.setAttribute('open', '');
        return;
      }
      document.documentElement.classList.add('mv-verhaal-open');
      this.dialog.showModal();
    }
  }
  customElements.define('mv-verhaal', MvVerhaal);
}
